import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, ShieldCheckIcon, LockIcon, FilterIcon } from 'lucide-react';
const sampleData = [{
  business: 'Apex Plumbing & Heating',
  owner: 'Robert Chen',
  title: 'Owner / Master Plumber',
  phone: '(512) 555-0192',
  email: 'robert@apexplumbingatx.com',
  address: '1204 S Congress Ave, Austin, TX 78704',
  industry: 'Home Services',
  state: 'TX',
  size: '11-25'
}, {
  business: 'Smile Bright Dental Clinic',
  owner: 'Dr. Sarah Jenkins',
  title: 'Lead Dentist & Founder',
  phone: '(312) 555-0143',
  email: 's.jenkins@smilebrightchicago.com',
  address: '450 N Michigan Ave, Chicago, IL 60611',
  industry: 'Healthcare',
  state: 'IL',
  size: '1-10'
}, {
  business: 'Golden Gate Auto Repair',
  owner: 'Michael Rodriguez',
  title: 'General Manager',
  phone: '(415) 555-0188',
  email: 'mike@goldengateauto.com',
  address: '890 Valencia St, San Francisco, CA 94110',
  industry: 'Automotive',
  state: 'CA',
  size: '11-25'
}, {
  business: 'Downtown Legal Partners',
  owner: 'Elena Martinez',
  title: 'Managing Partner',
  phone: '(212) 555-0121',
  email: 'emartinez@downtownlegal.nyc',
  address: '120 Broadway, New York, NY 10271',
  industry: 'Professional Services',
  state: 'NY',
  size: '26-50'
}, {
  business: 'Bella Vita Restaurant',
  owner: "James O'Connor",
  title: 'Owner & Executive Chef',
  phone: '(305) 555-0199',
  email: 'james@bellavitamiami.com',
  address: '100 Ocean Dr, Miami Beach, FL 33139',
  industry: 'Food & Beverage',
  state: 'FL',
  size: '26-50'
}, {
  business: 'Seattle Tech Solutions',
  owner: 'Marcus Johnson',
  title: 'CEO',
  phone: '(206) 555-0177',
  email: 'marcus@seattletech.io',
  address: '400 Pine St, Seattle, WA 98101',
  industry: 'Technology',
  state: 'WA',
  size: '11-25'
}, {
  business: 'Denver Landscape Pros',
  owner: 'Amanda Lewis',
  title: 'Owner',
  phone: '(303) 555-0134',
  email: 'alewis@denverlandscapes.com',
  address: '1500 Colorado Blvd, Denver, CO 80220',
  industry: 'Home Services',
  state: 'CO',
  size: '1-10'
}, {
  business: 'Phoenix Family Chiropractic',
  owner: 'Dr. David Kim',
  title: 'Clinic Director',
  phone: '(602) 555-0155',
  email: 'dkim@phoenixchiro.com',
  address: '200 E Camelback Rd, Phoenix, AZ 85012',
  industry: 'Healthcare',
  state: 'AZ',
  size: '1-10'
}, {
  business: 'Atlanta Logistics Group',
  owner: 'Maria Garcia',
  title: 'Operations Director',
  phone: '(404) 555-0166',
  email: 'mgarcia@atllogistics.net',
  address: '3000 Peachtree Rd, Atlanta, GA 30305',
  industry: 'Transportation',
  state: 'GA',
  size: '50+'
}, {
  business: 'Boston Heritage Real Estate',
  owner: 'Robert Taylor',
  title: 'Principal Broker',
  phone: '(617) 555-0122',
  email: 'rtaylor@bostonheritage.com',
  address: '150 Boylston St, Boston, MA 02116',
  industry: 'Real Estate',
  state: 'MA',
  size: '11-25'
}, {
  business: 'Vegas Event Planners',
  owner: 'Jennifer Wu',
  title: 'Founder',
  phone: '(702) 555-0188',
  email: 'jwu@vegasevents.com',
  address: '3000 Las Vegas Blvd S, Las Vegas, NV 89109',
  industry: 'Professional Services',
  state: 'NV',
  size: '11-25'
}, {
  business: 'Portland Organic Grocers',
  owner: 'Thomas Brown',
  title: 'Store Manager',
  phone: '(503) 555-0144',
  email: 'tbrown@portlandorganic.com',
  address: '1000 W Burnside St, Portland, OR 97209',
  industry: 'Retail',
  state: 'OR',
  size: '26-50'
}, {
  business: 'Dallas Fitness Center',
  owner: 'Lisa Patel',
  title: 'Owner',
  phone: '(214) 555-0133',
  email: 'lpatel@dallasfitness.net',
  address: '2000 McKinney Ave, Dallas, TX 75201',
  industry: 'Health & Wellness',
  state: 'TX',
  size: '11-25'
}, {
  business: 'Nashville Sound Studios',
  owner: 'William Clark',
  title: 'Studio Manager',
  phone: '(615) 555-0111',
  email: 'wclark@nashvillesound.com',
  address: '100 Music Square E, Nashville, TN 37203',
  industry: 'Media & Entertainment',
  state: 'TN',
  size: '1-10'
}, {
  business: 'Detroit Manufacturing Co',
  owner: 'Rachel Green',
  title: 'Plant Manager',
  phone: '(313) 555-0190',
  email: 'rgreen@detroitmfg.com',
  address: '500 Woodward Ave, Detroit, MI 48226',
  industry: 'Manufacturing',
  state: 'MI',
  size: '50+'
}];
export function DatabaseDataPreview() {
  const [activeRow, setActiveRow] = useState<number | null>(null);
  const [industryFilter, setIndustryFilter] = useState('All');
  const [stateFilter, setStateFilter] = useState('All');
  const [sizeFilter, setSizeFilter] = useState('All');
  const filteredData = useMemo(() => {
    return sampleData.filter(item => {
      if (industryFilter !== 'All' && item.industry !== industryFilter) return false;
      if (stateFilter !== 'All' && item.state !== stateFilter) return false;
      if (sizeFilter !== 'All' && item.size !== sizeFilter) return false;
      return true;
    });
  }, [industryFilter, stateFilter, sizeFilter]);
  return <section className="py-24 bg-white" data-id="element-3657">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3658">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-3659">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-3660">
            Preview the local business database
          </h2>
          <p className="text-xl text-slate-600" data-id="element-3661">
            Filter by industry, state, and size. Our local business listings
            include verified business owner emails, direct phone numbers, and
            firmographic data for local small businesses.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 shadow-xl overflow-hidden" data-id="element-3662">
          <div className="p-6 border-b border-slate-200 bg-slate-50" data-id="element-3663">
            <div className="flex flex-wrap items-center gap-3" data-id="element-3664">
              <div className="flex items-center gap-2 mr-auto" data-id="element-3665">
                <FilterIcon className="w-5 h-5 text-slate-400" data-id="element-3666" />
                <h3 className="text-lg font-bold text-slate-900 whitespace-nowrap" data-id="element-3667">
                  Filter local business listings
                </h3>
              </div>

              <select className="bg-white border border-slate-300 text-slate-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 shadow-sm" value={industryFilter} onChange={e => setIndustryFilter(e.target.value)} data-id="element-3668">
                <option value="All" data-id="element-3669">All Industries</option>
                <option value="Home Services" data-id="element-3670">Home Services</option>
                <option value="Healthcare" data-id="element-3671">Healthcare</option>
                <option value="Automotive" data-id="element-3672">Automotive</option>
                <option value="Professional Services" data-id="element-3673">
                  Professional Services
                </option>
                <option value="Food & Beverage" data-id="element-3674">Food & Beverage</option>
                <option value="Retail" data-id="element-3675">Retail</option>
              </select>

              <select className="bg-white border border-slate-300 text-slate-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 shadow-sm" value={stateFilter} onChange={e => setStateFilter(e.target.value)} data-id="element-3676">
                <option value="All" data-id="element-3677">All States</option>
                <option value="TX" data-id="element-3678">Texas</option>
                <option value="CA" data-id="element-3679">California</option>
                <option value="NY" data-id="element-3680">New York</option>
                <option value="FL" data-id="element-3681">Florida</option>
                <option value="IL" data-id="element-3682">Illinois</option>
              </select>

              <select className="bg-white border border-slate-300 text-slate-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 shadow-sm" value={sizeFilter} onChange={e => setSizeFilter(e.target.value)} data-id="element-3683">
                <option value="All" data-id="element-3684">All Sizes</option>
                <option value="1-10" data-id="element-3685">1-10 Employees</option>
                <option value="11-25" data-id="element-3686">11-25 Employees</option>
                <option value="26-50" data-id="element-3687">26-50 Employees</option>
                <option value="50+" data-id="element-3688">50+ Employees</option>
              </select>

              {(industryFilter !== 'All' || stateFilter !== 'All' || sizeFilter !== 'All') && <button onClick={() => {
              setIndustryFilter('All');
              setStateFilter('All');
              setSizeFilter('All');
            }} className="text-xs font-medium text-slate-500 hover:text-slate-700 transition-colors underline underline-offset-2" data-id="element-3689">
                  Clear all
                </button>}
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-3690">
            <table className="w-full text-sm text-left" data-id="element-3691">
              <thead data-id="element-3692">
                <tr className="text-slate-500 font-semibold border-b border-slate-200 bg-slate-50/50" data-id="element-3693">
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-3694">Business name</th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-3695">
                    Verified owner / contact
                  </th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-3696">Title</th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-3697">
                    <div className="flex items-center gap-2" data-id="element-3698">
                      Email
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-700" data-id="element-3699">
                        Verified
                      </span>
                    </div>
                  </th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-3700">
                    <div className="flex items-center gap-2" data-id="element-3701">
                      Phone
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-700" data-id="element-3702">
                        Verified
                      </span>
                    </div>
                  </th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-3703">Address</th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-3704">Industry</th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-3705">Employees</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-3706">
                {filteredData.length > 0 ? filteredData.map((row, idx) => {
                const isBlurred = idx >= 3;
                return <motion.tr key={idx} onHoverStart={() => !isBlurred && setActiveRow(idx)} onHoverEnd={() => !isBlurred && setActiveRow(null)} className={`transition-all duration-200 ${isBlurred ? 'bg-slate-50/50 select-none' : 'cursor-pointer'} ${activeRow === idx && !isBlurred ? 'bg-blue-50' : !isBlurred ? 'hover:bg-slate-50' : ''}`} data-id="element-3707">
                        <td className="py-4 px-4 font-semibold text-slate-900 whitespace-nowrap" data-id="element-3708">
                          {row.business}
                        </td>
                        <td className="py-4 px-4 text-slate-600 whitespace-nowrap" data-id="element-3709">
                          {row.owner}
                        </td>
                        <td className="py-4 px-4 text-slate-500 whitespace-nowrap" data-id="element-3710">
                          {row.title}
                        </td>
                        <td className="py-4 px-4 whitespace-nowrap relative" data-id="element-3711">
                          {isBlurred ? <div className="flex items-center justify-center absolute inset-0 bg-white/40 backdrop-blur-[4px] z-10" data-id="element-3712">
                              <LockIcon className="w-4 h-4 text-slate-400" data-id="element-3713" />
                            </div> : null}
                          <div className={`flex items-center gap-1.5 ${isBlurred ? 'opacity-30' : ''}`} data-id="element-3714">
                            <ShieldCheckIcon className="w-3.5 h-3.5 text-green-600 flex-shrink-0" data-id="element-3715" />
                            <span className="text-blue-600 font-medium" data-id="element-3716">
                              {row.email}
                            </span>
                          </div>
                        </td>
                        <td className="py-4 px-4 whitespace-nowrap relative" data-id="element-3717">
                          {isBlurred ? <div className="flex items-center justify-center absolute inset-0 bg-white/40 backdrop-blur-[4px] z-10" data-id="element-3718">
                              <LockIcon className="w-4 h-4 text-slate-400" data-id="element-3719" />
                            </div> : null}
                          <div className={`flex items-center gap-1.5 text-slate-600 ${isBlurred ? 'opacity-30' : ''}`} data-id="element-3720">
                            <ShieldCheckIcon className="w-3.5 h-3.5 text-green-600 flex-shrink-0" data-id="element-3721" />
                            <span data-id="element-3722">{row.phone}</span>
                          </div>
                        </td>
                        <td className="py-4 px-4 text-slate-600 whitespace-nowrap" data-id="element-3723">
                          {row.address}
                        </td>
                        <td className="py-4 px-4 text-slate-600 whitespace-nowrap" data-id="element-3724">
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-3725">
                            {row.industry}
                          </span>
                        </td>
                        <td className="py-4 px-4 text-slate-600 whitespace-nowrap" data-id="element-3726">
                          {row.size}
                        </td>
                      </motion.tr>;
              }) : <tr data-id="element-3727">
                    <td colSpan={8} className="py-12 text-center text-slate-500" data-id="element-3728">
                      No local businesses found matching your filters. Try
                      adjusting your criteria.
                    </td>
                  </tr>}
              </tbody>
            </table>
          </div>

          <div className="p-4 bg-slate-50 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-3729">
            <p className="text-sm text-slate-500" data-id="element-3730">
              Showing {filteredData.length} of{' '}
              <strong className="text-slate-900" data-id="element-3731">200M+</strong> verified local
              business records.
            </p>
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors" data-id="element-3732">
              <DownloadIcon className="w-4 h-4" data-id="element-3733" />
              Unlock full database
            </a>
          </div>
        </div>
      </div>
    </section>;
}